import React from "react";
import { useDevAgentStore } from "@/stores/devAgentStore";
import { FeedChatAgent } from "../FeedChatAgent";
import { ApprovalInlineCard } from "./ApprovalInlineCard";
import { ChatUser } from "./ChatUser";
import { CheckpointCard } from "./CheckpointCard";
import { ClarificationCard } from "./ClarificationCard";
import { ErrorItem } from "./ErrorItem";
import { InlinePlanCard } from "./InlinePlanCard";
import { IntentConfirmCard } from "./IntentConfirmCard";
import type { FeedItemComponentProps } from "./types";

export const FEED_ITEM_RENDERERS: Record<
  string,
  React.FC<FeedItemComponentProps>
> = {
  chat_user: ({ item }) => (
    <ChatUser content={item.data.content} timestamp={item.timestamp} />
  ),
  chat_agent: ({ item, onFeedback }) => (
    <FeedChatAgent
      content={item.data.content}
      itemId={item.id}
      timestamp={item.timestamp}
      onFeedback={onFeedback}
      readOnly={item.data.readOnly}
      toolCalls={item.data.toolCalls || item.data.tool_calls}
      messageUuid={item.data.messageUuid}
      blockedAction={item.data.metadata?.blocked_action}
    />
  ),
  tool_call: () => null,
  plan: ({ item, onSendMessage, disabled }) => (
    <InlinePlanCard
      item={item}
      onSendMessage={onSendMessage}
      disabled={disabled}
    />
  ),
  code_change: () => null,
  approval: ({ item, onSendMessage }) => (
    <ApprovalInlineCard item={item} onSendMessage={onSendMessage} />
  ),
  thinking: () => null,
  clarification: ({ item, onSendMessage, disabled }) => (
    <ClarificationCard
      data={item.data}
      itemId={item.id}
      onSendMessage={onSendMessage}
      disabled={disabled}
    />
  ),
  checkpoint: ({ item, onSendMessage, disabled }) => (
    <CheckpointCard
      data={item.data}
      onSendMessage={onSendMessage}
      disabled={disabled}
    />
  ),
  error: ({ item, onSendMessage }) => (
    <ErrorItem
      message={item.data.message}
      onRetry={
        onSendMessage
          ? () => {
              const items = useDevAgentStore.getState().feedItems;
              const lastUser = [...items]
                .reverse()
                .find((f) => f.type === "chat_user");
              if (lastUser?.data?.content)
                onSendMessage(lastUser.data.content);
            }
          : undefined
      }
    />
  ),
  intent_confirm: ({ item, onSendMessage }) => (
    <IntentConfirmCard item={item} onSendMessage={onSendMessage} />
  ),
};
